export default "__VITE_ASSET__mAPFgb4C__"